import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchCatchAllProps = { startDate: Moment; endDate: Moment };

export type FetchCatchAll = (
  dates: FetchCatchAllProps,
) => void;

const fetchCatchAll = ({
  startDate,
  endDate,
}: FetchCatchAllProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport("catch_all", dispatch, params);
};

export default fetchCatchAll;
